"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = {
  props: {
    tip: {
      type: String,
      default: '同步当前配置'
    }
  },
  methods: {
    click: function click() {
      this.$emit('click');
    }
  }
};
exports.default = _default;